module.exports = "/packs/media/images/icon_investments-5fd94e6536968d782e92b6533d2816ee.png";